import { type FC, type ReactNode } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useIntl } from 'react-intl'

import { type UserOrderResponseWithFlagsSubOrdersInner } from '@redteclab/api/clients/bully'

import { Button } from 'base-ui'

import { directContactFormAccessorIsProductType } from '../../../../../direct-contact'
import { type DirectContactFormValues } from '../../DirectContactFormModel'
import { useDirectContactFormOrderProductsSelectionContext } from '../DirectContactFormOrderProductsSelectionContext'

export const DirectContactFormOrderProductsSelectionCardButton: FC<{
  children: ReactNode
  subOrder: UserOrderResponseWithFlagsSubOrdersInner
}> = ({ children, subOrder }) => {
  const intl = useIntl()
  const { control, setValue } = useFormContext<DirectContactFormValues>()
  const { isMiraklReturnAvailabilityLoading, onClose, onSelectProducts } =
    useDirectContactFormOrderProductsSelectionContext()
  const currentOrderId = useWatch({ control, name: 'orderId' })
  const subject = useWatch({ control, name: 'subject' })
  const { subOrderId } = subOrder

  if (!subOrderId) {
    return null
  }

  return (
    <Button
      className="w-full justify-between rounded-m bg-light-primary-low p-4 text-start shadow-m hover:bg-light-brand-medium"
      data-qa-id="direct-contact-form-order-selection-card"
      disabled={isMiraklReturnAvailabilityLoading}
      onClick={() => {
        if (currentOrderId !== subOrderId) {
          setValue('images', [], { shouldDirty: true })
          setValue('productCode', '', { shouldDirty: true })
          setValue('selectedProducts', [], { shouldDirty: true })
        }

        setValue('orderId', subOrderId, {
          shouldDirty: true,
          shouldValidate: true,
        })

        if (directContactFormAccessorIsProductType(intl, subject)) {
          onSelectProducts(subOrder)
        } else {
          onClose()
        }
      }}
      type="button"
      variant="text"
    >
      {children}
    </Button>
  )
}
